import React from "react";
import CloseIcon from "@/images/icons/purple-close-icon.svg";
import "./PrereqModalHeader.scss";

interface ModalHeaderProps {
  title: string;
  onClose?: () => void;
  className?: string;
}

const ModalHeader: React.FC<ModalHeaderProps> = ({
  title,
  onClose,
  className = ""
}) => {
  return (
    <div className={`prereq-header d-flex flex-column align-items-start align-self-stretch ${className}`}>
      <div className="prereq-header-container d-flex justify-content-between align-items-center align-self-stretch">
        <div className="prereq-header-container-title d-flex align-items-center gap-1">
          <h3>{title}</h3>
          {onClose && (
            <button onClick={onClose} type="button">
              <img src={CloseIcon} alt="Close" />
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ModalHeader;